module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrapper animate fadeIn"
  }, [_c('div', {
    staticClass: "profile-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3"
  }, [_c('h2', {
    staticClass: "header-title"
  }, [_vm._v("แก้ไขข้อมูลส่วนตัว")]), _vm._v(" "), _c('form', {
    staticClass: "form form--box border",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_c('h3', {
    staticClass: "form__title"
  }, [_vm._v("ข้อมูลส่วนตัว")]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("อีเมล")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.email),
      expression: "info.email"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.isError('email')
    },
    attrs: {
      "type": "text",
      "name": "v",
      "id": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.info.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.email.empty),
      expression: "$v.$errors.email.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกอีเมล")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.email.invalid),
      expression: "$v.$errors.email.invalid"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกอีเมลให้ถูกต้อง")])]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("ชื่อจริง")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.firstName),
      expression: "info.firstName"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.isError('firstName')
    },
    attrs: {
      "type": "text",
      "id": "firstName"
    },
    domProps: {
      "value": (_vm.info.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.firstName.empty),
      expression: "$v.$errors.firstName.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกชื่อของคุณ")])]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("นามสกุล")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.lastName),
      expression: "info.lastName"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.isError('lastName')
    },
    attrs: {
      "type": "text",
      "id": "lastName"
    },
    domProps: {
      "value": (_vm.info.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.lastName.empty),
      expression: "$v.$errors.lastName.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกนามสกุล")])]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "telNo"
    }
  }, [_vm._v("เบอร์โทรศัพท์")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.telNo),
      expression: "info.telNo"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.isError('telNo')
    },
    attrs: {
      "type": "text",
      "id": "telNo",
      "placeholder": "0899999999"
    },
    domProps: {
      "value": (_vm.info.telNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "telNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.telNo.empty),
      expression: "$v.$errors.telNo.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาระบุเบอร์โทรศัพท์ที่ติดต่อได้")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.$errors.telNo.empty && _vm.$v.$errors.telNo.invalid),
      expression: "!$v.$errors.telNo.empty && $v.$errors.telNo.invalid"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกเบอร์โทรให้ถูกต้อง")])]), _vm._v(" "), (!_vm.passwordVisible) ? _c('div', {
    staticClass: "text-center mt-15 mb-15"
  }, [_c('button', {
    staticClass: "btn btn--center btn--white btn--full",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showPassword()
      }
    }
  }, [_vm._v("กดเพื่อเปลี่ยนรหัสผ่าน")])]) : _vm._e(), _vm._v(" "), (_vm.passwordVisible) ? _c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "password1"
    }
  }, [_vm._v("รหัสผ่าน")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.password1),
      expression: "info.password1"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.isError('password1')
    },
    attrs: {
      "type": "password",
      "id": "password1"
    },
    domProps: {
      "value": (_vm.info.password1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "password1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.password1.empty),
      expression: "$v.$errors.password1.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกรหัสผ่าน")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.password1.minLength),
      expression: "$v.$errors.password1.minLength"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("รหัสผ่านต้องยาวไม่น้อยกว่า 6 ตัวอักษร")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.password1.tooEasy),
      expression: "$v.$errors.password1.tooEasy"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาใช้รหัสผ่านที่เดายากกว่านี้")])]) : _vm._e(), _vm._v(" "), (_vm.passwordVisible) ? _c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "password2"
    }
  }, [_vm._v("ยืนยันรหัสผ่าน")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.password2),
      expression: "info.password2"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.isError('password2')
    },
    attrs: {
      "type": "password",
      "id": "password2"
    },
    domProps: {
      "value": (_vm.info.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "password2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.password2.empty),
      expression: "$v.$errors.password2.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกรหัสผ่าน")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.$errors.password2.empty && _vm.$v.$errors.password2.unmatched),
      expression: "!$v.$errors.password2.empty && $v.$errors.password2.unmatched"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกรหัสผ่านให้ตรงกัน")])]) : _vm._e(), _vm._v(" "), _c('address-form', {
    ref: "addressForm",
    staticClass: "mt-30",
    attrs: {
      "showButton": false,
      "back": false,
      "withBorder": false,
      "withPadding": false
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn--purple btn--full mb-15",
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("บันทึก")])], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a2f7167","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfilePage.vue
// module id = 1160
// module chunks = 0